import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EASE = [0.76, 0, 0.24, 1];
const DURATION_MS = 2600;

export const WelcomeIntro = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => setVisible(false), DURATION_MS);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    if (!visible) document.body.style.overflow = '';
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="welcome-intro"
          onClick={() => setVisible(false)}
          exit={{ y: '-100%' }}
          transition={{ duration: 0.9, ease: EASE }}
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#121826] cursor-pointer"
          style={{ background: 'radial-gradient(ellipse at center, #1B275B 0%, #121826 70%)' }}
        >
          <motion.div
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col items-center px-8"
          >
            <motion.img
              src="/logo-mark-light.png"
              alt="Stemma della Repubblica Italiana"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, ease: 'easeOut' }}
              className="h-20 sm:h-24 md:h-28 w-auto"
            />
            <motion.img
              src="/logo-text-gold.png"
              alt="Accordini Carillo - Notai Associati"
              data-testid="welcome-intro-logo"
              initial={{ clipPath: 'inset(0 100% 0 0)', opacity: 0.4 }}
              animate={{ clipPath: 'inset(0 0% 0 0)', opacity: 1 }}
              transition={{ duration: 1, delay: 0.55, ease: 'easeInOut' }}
              className="mt-6 md:mt-8 w-[78vw] max-w-[420px] h-auto"
            />
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.6, delay: 1.4, ease: 'easeOut' }}
              className="mt-6 h-px w-32 bg-[#C9A227] origin-center"
            />
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 1.6 }}
              className="mt-4 text-[10px] sm:text-xs tracking-[0.4em] uppercase text-white/60"
            >
              Verona · Valeggio sul Mincio · Peschiera del Garda
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
